module.exports = __webpack_public_path__ + "static/media/A1-36-Oblithul-cod144.d764fd0f.png";